import { ArrowLeft, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, getAssetUrl } from "../lib/api";

export default function GalleryPage() {
  const [site, setSite] = useState(null);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    api.get("/site").then(({ data }) => setSite(data));
  }, []);

  if (!site) {
    return <div className="site-loading" data-testid="gallery-loading-state">Galeri hazırlanıyor</div>;
  }

  const images = site.content.gallery_images || [];

  return (
    <main className="gallery-page" data-testid="gallery-page">
      <header className="gallery-header">
        <Link to="/" data-testid="gallery-back-home-link"><ArrowLeft size={17} /> Ana sayfa</Link>
        <span>EYLÜL FOTOĞRAFÇILIK</span>
      </header>
      <section className="gallery-intro"><p>SEÇİLMİŞ KARELER</p><h1>Galeri</h1></section>
      <section className="gallery-panels" data-testid="gallery-panels">
        {images.map((image, index) => (
          <button className="gallery-panel" key={`${image}-${index}`} onClick={() => setActiveImage(image)} data-testid={`gallery-panel-${index + 1}`} aria-label={`Galeri görseli ${index + 1} aç`}>
            <img src={getAssetUrl(image)} alt={`Eylül Fotoğrafçılık galeri karesi ${index + 1}`} data-testid={`gallery-image-${index + 1}`} />
          </button>
        ))}
      </section>
      {activeImage && <div className="gallery-lightbox" data-testid="gallery-lightbox"><button className="gallery-close" onClick={() => setActiveImage(null)} data-testid="gallery-lightbox-close-button" aria-label="Görseli kapat"><X size={22} /></button><img src={getAssetUrl(activeImage)} alt="Eylül Fotoğrafçılık galeri görseli" data-testid="gallery-lightbox-image" /></div>}
    </main>
  );
}